import React from "react";
import styles from "./styles.module.scss"

const Explore = () => {
    return(
        <div className={styles["explore"]}>
            <h1>Исследуй <span>Волгоград</span></h1>
            <div className={styles["content"]}>
                <div className={styles["left-side"]}>
                    <div className={styles["card1"]}>
                        <div>
                            <h1>
                            Музей-панорама "Сталинградская битва"
                            </h1>
                        </div>
                    </div>
                    <div className={styles["card2"]}>
                        <div>
                            <h1>
                            Площадь Павших борцов
                            </h1>
                        </div>
                    </div>
                    <div className={styles["card3"]}>
                        <div>
                            <h1>
                            Волгоградский планетарий
                            </h1>
                        </div>
                    </div>
                </div>
                <div className={styles["right-side"]}>
                    <button className={styles['open-map']}>
                        <p>Посмотреть на карте</p>
                    </button>
                    <div className={styles["card4"]}>
                        <div>
                            <h1>
                            «Героям Сталинградской битвы» на Мамаевой Кургане
                            </h1>
                        </div>
                    </div>
                    <div className={styles["card5"]}>
                        <div>
                            <h1>
                            Стадион «Волгоград Арена»
                            </h1>
                        </div>
                    </div>
                    <div className={styles["card6"]}>
                        <div>
                            <h1>
                            Волгоградская набережная
                            </h1>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default Explore;